'use strict';

var React = require('react');
var reactFinalForm = require('react-final-form');
var Form = require('@piconetworks/form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var US = {
  name: 'United States',
  Component: function Component(_ref) {
    var name = _ref.name,
        required = _ref.required,
        rest = _objectWithoutProperties(_ref, ["name", "required"]);

    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Address Line 1"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".address1"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Address Line 2"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".address2"),
      component: Form__default['default'].Input,
      type: "text"
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "City"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".city"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "State"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".state"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Zip Code"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".post_code"),
      component: Form__default['default'].Input,
      type: "number"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))));
  }
};

var CA = {
  name: 'Canada',
  Component: function Component(_ref) {
    var name = _ref.name,
        required = _ref.required,
        rest = _objectWithoutProperties(_ref, ["name", "required"]);

    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Address Line 1"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".address1"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Address Line 2"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".address2"),
      component: Form__default['default'].Input,
      type: "text"
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "City"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".city"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Province"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".province"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Postal Code"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".post_code"),
      component: Form__default['default'].Input,
      type: "number"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))));
  }
};

var Other = {
  name: 'Other',
  Component: function Component(_ref) {
    var name = _ref.name,
        required = _ref.required,
        rest = _objectWithoutProperties(_ref, ["name", "required"]);

    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Address Line 1"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".address1"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Address Line 2"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".address2"),
      component: Form__default['default'].Input,
      type: "text"
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "City"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".city"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Region"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".region"),
      component: Form__default['default'].Input,
      type: "text"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
      label: "Zip Code"
    }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
      name: "".concat(name, ".post_code"),
      component: Form__default['default'].Input,
      type: "number"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest))));
  }
};

var countries = {
  US: US,
  CA: CA,
  Other: Other
};

var Address = function Address() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var name = _ref.name,
      fieldContainerProps = _ref.fieldContainerProps,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      required = _ref.required;
      _ref.defaultValue;
      var rest = _objectWithoutProperties(_ref, ["name", "fieldContainerProps", "description", "required", "defaultValue"]);

  var form = reactFinalForm.useForm();

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      country = _useState2[0],
      changeCountry = _useState2[1];

  var countryData = countries[country];

  var AddressFields = (countryData === null || countryData === void 0 ? void 0 : countryData.Component) || function () {
    return null;
  };

  var fieldName = "".concat(name, ".country");
  return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, fieldContainerProps, /*#__PURE__*/React__default['default'].createElement("p", null, description), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, {
    label: "Country"
  }, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
    name: fieldName,
    component: function component(props) {
      return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Dropdown, _extends({}, props, {
        input: {
          value: country,
          onChange: function onChange(val) {
            changeCountry(val);
            form.change(fieldName, val);
          },
          onBlur: function onBlur() {}
        }
      }));
    },
    value: country,
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest, {
    options: Object.entries(countries).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2);
          _ref3[0];
          var _ref3$ = _ref3[1],
          name = _ref3$.name,
          Component = _ref3$.Component;

      return !!name && !!Component;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          name = _ref5[1].name;

      return {
        label: name,
        value: key
      };
    })
  }))), /*#__PURE__*/React__default['default'].createElement(AddressFields, _extends({
    name: name,
    required: required
  }, rest)));
};

module.exports = Address;
